const ensureFileName = (name, type) => {
  const base = typeof name === "string" && name.trim() ? name.trim() : "image";
  const hasExt = /\.[a-z0-9]+$/i.test(base);
  const ext = (() => {
    const t = String(type || "").toLowerCase();
    if (t.includes("png")) return "png";
    if (t.includes("webp")) return "webp";
    return "jpg";
  })();
  if (hasExt) return base;
  return `${base}.${ext}`;
};

const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", (error) => reject(error));
    image.src = url;
  });

export default async function cropImage({ imageSrc, pixelCrop, fileName, fileType }) {
  if (!imageSrc) throw new Error("Missing imageSrc");
  if (!pixelCrop) throw new Error("Missing pixelCrop");

  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  if (!ctx) {
    throw new Error("Canvas not supported");
  }

  canvas.width = Math.max(1, Math.floor(pixelCrop.width));
  canvas.height = Math.max(1, Math.floor(pixelCrop.height));

  ctx.drawImage(
    image,
    Math.floor(pixelCrop.x),
    Math.floor(pixelCrop.y),
    Math.floor(pixelCrop.width),
    Math.floor(pixelCrop.height),
    0,
    0,
    Math.floor(pixelCrop.width),
    Math.floor(pixelCrop.height)
  );

  const type = typeof fileType === "string" && fileType.startsWith("image/") ? fileType : "image/jpeg";
  const outName = ensureFileName(fileName, type);

  const blob = await new Promise((resolve) => {
    canvas.toBlob(
      (b) => resolve(b),
      type,
      type === "image/png" ? undefined : 0.92
    );
  });

  if (!blob) {
    throw new Error("Unable to crop image");
  }

  const file = new File([blob], outName, { type });
  const dataUrl = canvas.toDataURL(type, type === "image/png" ? undefined : 0.92);

  return { file, dataUrl };
}
